(function() {
	'use strict';
	angular.module('nasracApp').factory('Revenue', Revenue);

	Revenue.$inject = [ '$resource' ];

	function Revenue($resource) {
		var resourceUrl = 'api/revenue';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/revenue/reportdates',
				isArray : true
			},

			'download' : {
				method : 'GET',
				url : 'api/revenue/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();
